module.exports = __webpack_public_path__ + "static/media/badge.65825ecb.svg";